module.exports = __webpack_public_path__ + "img/offer.0340eed2.png";